import Client, { Local } from "../client";
import { TOKEN_STORAGE_KEY } from "./auth-storage";

/**
 * Where the API lives, from the browser's perspective.
 *
 * - In dev (Vite at :3000), we cross-origin to Encore at :4000. Encore's dev
 *   mode allows that cross-origin call.
 * - In a built bundle, the Go binary serves both the SPA and the API on the
 *   same host:port, so we call the same origin that served the page. This
 *   avoids CORS entirely and also works behind any reverse proxy / public
 *   IP / domain the binary happens to be bound to.
 */
const apiBaseURL: string = (() => {
  if (import.meta.env.DEV) return Local;
  if (typeof window !== "undefined") return window.location.origin;
  return Local;
})();

export const buildClient = (): Client => {
  return new Client(apiBaseURL, {
    auth: () => {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY);
      return { Authorization: token ? `Bearer ${token}` : "" };
    },
  });
};

export const apiClient = buildClient();
